export function concatSlash(string) {
  let result = string;
  if (result && !result.endsWith('/')) {
    result += '/';
  }
  return result;
}


class UrlNormalizer {
  properties = {
    endsWithSlash: undefined,
  }

  context = {
    not: false,
  }

  apply(url) {
    if (typeof url !== 'string') return url;
    let normalized = url;

    if (this.properties.endsWithSlash !== undefined) {
      if (this.properties.endsWithSlash && !normalized.endsWith('/')) normalized += '/';
      if (!this.properties.endsWithSlash && normalized.endsWith('/')) {
        normalized = normalized.substring(0, normalized.length - 1);
      }
    }

    return normalized;
  }

  endsWithSlash() {
    this.properties.endsWithSlash = !this.context.not;
    this.context.not = false;
    return this;
  }

  not() {
    this.context.not = true;
    return this;
  }
}

/**
 * Può "normalizzare" un url applicando alcune trasformazioni.
 * @see UrlNormalizer
 * @example
 * normalizer().endsWithSlash().apply('http://pratiche.uat1.cgn.it/')
 * normalizer().not().endsWithSlash().apply('http://pratiche.uat1.cgn.it/')
 */
export function normalizer() {
  return new UrlNormalizer();
}
